import {
  ManagementPartyDto,
  PartyEmailQuotationExchangeChannelDto,
  PartyManualQuotationExchangeChannelDto,
  PartyQuotationExchangeChannelDto,
  PartyScsnQuotationExchangeChannelDto,
  QuotationExchangeChannel,
} from 'services/APIs/InternalAPI/internal-api.contracts'

export type PartyQuotationExchangeChannel =
  | PartyManualQuotationExchangeChannelDto
  | PartyScsnQuotationExchangeChannelDto
  | PartyEmailQuotationExchangeChannelDto
  | PartyQuotationExchangeChannelDto

export const getPartyQuotationExchangeChannels = (
  party: ManagementPartyDto,
) =>
  (party.quotationExchangeChannels || []) as PartyQuotationExchangeChannel[]

export const isManualChannel = (
  channel: PartyQuotationExchangeChannel,
): channel is PartyManualQuotationExchangeChannelDto =>
  channel.channel === QuotationExchangeChannel.Manual

export const isScsnChannel = (
  channel: PartyQuotationExchangeChannel,
): channel is PartyScsnQuotationExchangeChannelDto =>
  channel.channel === QuotationExchangeChannel.Scsn

export const isEmailChannel = (
  channel: PartyQuotationExchangeChannel,
): channel is PartyEmailQuotationExchangeChannelDto =>
  channel.channel === QuotationExchangeChannel.Email
